import { BillingModel } from '@/modules/billing/entities/billing.enums';
import useCompany from '@/shared/hooks/useCompany/useCompany';

export const useBillingModel = () => {
  const { company } = useCompany();

  return {
    companyBillingModel: company.billing?.model,
    isCompanyFeeForService: company.billing?.model === BillingModel.FEE_FOR_SERVICE,
    isCompanyFeeForLife: company.billing?.model === BillingModel.FEE_FOR_LIFE,
  };
}
